<Slide :i :slide>
    <div ref:container class="bespoke-container gallery gallery-{{ slide.display == 'inset' ? 'inset' : 'full'}}">
      <div ref:wrapper class="bespoke-wrapper">
        {{#each slide.slides as slide, s}}
        <:Component {getComponent(slide.type)} :slide i={{s}} parent_slide={{i}} bind:current_slide />
        {{/each}}
      </div>
    </div>
    <div class="gallery__controls">
        <div ref:prev class="gallery__button-prev" on:click="prev()"></div>
        <div ref:count class="gallery__count">{{ slide_count }} <span class="gallery__count-of">of</span> {{ slide.slides.length }}</div>
        <div ref:next class="gallery__button-next" on:click="next()"></div>
        {{#if $gallery_prompt_display}}
        <div class="gallery__controls-prompt">
            Explore
        </div>
        {{/if}}
    </div>
</Slide>

<script>
import bespoke from 'bespoke'
import loop from 'bespoke-loop'
import keys from 'bespoke-keys'
import Slide from '../Slide.html'
import GallerySlide from './gallery/GallerySlide.html'
import Video from './gallery/GalleryVideo.html'

import { setHintTimeout, clearHintTimeout } from '../helpers'

const SLIDES = {Slide, Video};

export default {

    components: {
        Slide,
        GallerySlide,
        Video,
    },

    data() {
        return {
            current_slide: 0,
            slide_count: 0,
        }
    },

    oncreate() {

        this.observers = [];

        this.gallery = bespoke.from({ parent: this.refs.wrapper, slides: '.bespoke-slide__gallery' }, [
            loop(),
            keys('horizontal'),
        ]);

        this.observers.push(this.store.observe('current_slide', current => {
            if (current === this.get('i')) {
                this.gallery.slide(0);
            } else {
                this.set({ current_slide: -1 });
            };
        }));

        this.observe('current_slide', (current, previous) => {
            let slide_count = current == -1 ? previous + 1 : current + 1;
            this.set({slide_count: slide_count});
        });

        this.gallery.on('activate', e => {
            this.set({ current_slide: e.index });
            if( e.index + 1 == this.get('slide').slides.length ) {
                setHintTimeout(this.store.get('scroll_hint_delay'));
            }
        });

        this.gallery.on('next', e => {
            if(this.store.get('gallery_prompt_display')) this.store.set({gallery_prompt_display: false});
        });

    },

    ondestroy() {
        for (let i = this.observers.length - 1; i >= 0; i--) {
            this.observers[i].cancel()
        }
    },

    helpers: {

        getComponent(name) {
            return SLIDES[name] || GallerySlide;
        }
    },

    methods: {
        next() {
            this.gallery.next();
        },

        prev() {
            this.gallery.prev();
        }
    }
}
</script>